import { Box, Divider, Grid, Tab } from '@mui/material';
import { SyntheticEvent, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { StyledTabs } from '../../common/StyledComponents';
import { scrollableY } from '../../common/theme/scrollbar';
import { RootState } from '../../store';
import { getSelectedCustomerId } from './redux/customerSelectors';
import { customerSelected } from './redux/customerSlices';
import CustomerTree from './CustomerTree';
import CreateCustomerDialog from './dialogs/CreateCustomerDialog';
import GeneralCustomerTab from './Tabs/General/GeneralCustomerTab';
import PricelistCustomerTab from './Tabs/Pricelists/PricelistCustomerTab';

const mapStateToProps = (state: RootState) => ({
    selectedCustomerId: getSelectedCustomerId(state),
    showCreateCustomerDialog: state.customers.ui.isCreateCustomerDialogOpen,
    parentCustomerId: state.customers.ui.createCustomerParentCustomerId
});

type Props = ReturnType<typeof mapStateToProps>;

const Customer = ({ selectedCustomerId, showCreateCustomerDialog }: Props) => {
    const [tabIndex, setTabIndex] = useState(0);

    const dispatch = useDispatch();
    const handleCustomersSelected = (customerIds: number | number[]) => {
        dispatch(customerSelected(Array.isArray(customerIds) ? customerIds[0] : customerIds));
    };

    const handleTabChange = (_: SyntheticEvent<Element, Event>, newTabIndex: number) => {
        setTabIndex(newTabIndex);
    };

    return (
        <>
            <Grid container sx={{ flexFlow: 'row' }}>
                <Grid item xs={3} sx={theme => ({ ...scrollableY(theme) })}>
                    <CustomerTree
                        multiSelect={false}
                        selectedCustomerIds={selectedCustomerId ?? 0}
                        setSelectedCustomerIds={handleCustomersSelected}
                    />
                </Grid>
                <Divider orientation="vertical" flexItem />

                <Grid item xs={9} sx={{ paddingLeft: '10px' }}>
                    <StyledTabs
                        value={tabIndex}
                        onChange={handleTabChange}
                        indicatorColor="primary"
                        textColor="primary"
                    >
                        <Tab label="General" />
                        <Tab label="Pricelists" />
                    </StyledTabs>
                    <Box p={2}>
                        {tabIndex === 0 && <GeneralCustomerTab />}
                        {tabIndex === 1 && <PricelistCustomerTab />}
                    </Box>
                </Grid>
            </Grid>
            {showCreateCustomerDialog && <CreateCustomerDialog />}
        </>
    );
};
export default connect(mapStateToProps)(Customer);
